import React from "react"

import classNames from "classnames"

import { WithClassName } from "shared/types/WithClassName"
import { RoomTypeInput } from "shared/ui/room-type-input/RoomTypeInput"

export interface ProductFilterRoomTypeInputProps extends WithClassName {
  loading?: boolean
  disabled?: boolean
  elevated?: boolean
}

export const ProductFilterRoomTypeInput = React.memo(
  ({
    loading,
    disabled,
    elevated,
    className
  }: ProductFilterRoomTypeInputProps) => {
    return (
      <RoomTypeInput
        loading={loading}
        disabled={disabled}
        elevated={elevated}
        className={classNames("product-filter__room-types", className)}
      />
    )
  }
)

ProductFilterRoomTypeInput.displayName = "ProductFilterRoomTypeInput"
